"use client";

import { useState } from "react";
import { useSearchParams } from "next/navigation";

/**
 * Page number state for a paginated table, read from the URL query param on
 * mount. The caller is expected to also pass the same `pageParamName` to
 * <TablePagination> so page changes write back to the URL.
 */
export function usePersistedPage(paramName = "page"): [number, (page: number) => void] {
  const searchParams = useSearchParams();

  const [page, setPage] = useState(() => {
    return parseInt(searchParams.get(paramName) || "1", 10) || 1;
  });

  return [page, setPage];
}
